import { render, staticRenderFns } from "./ResetAdminPassword.vue?vue&type=template&id=77115c2e&"
import script from "./ResetAdminPassword.vue?vue&type=script&lang=js&"
export * from "./ResetAdminPassword.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports